export const selectIsLoading = (state) => {
  return (
    state.campaign.loading ||
    state.business.loading ||
    state.playground.loading ||
    state.promotions.loading
  );
};
